
var api = {}
api.common = {
  header: () => '/header.html',
  footer: () => `/footer.html`
}
api.reservation = {
  // 产品型号
  findProModel: () => `/casch/homePage?method=findProModel`,
  // 支付
  payService: () => `/omniapp/bookservice/pay4Service`,
  addBookService: () => `/omniapp/bookservice/addBookService`,
  address: () => `/CaschReservationService/Data/`,
  queryDateRange: () => `/omniapp/bookservice/queryDateRange`,

  queryStatus: () => `/omniapp/bookservice/queryStatus`,
  queryPaidStatus: () => `/omniapp/bookservice/queryPaidStatus`,
  vallicode: () => `/omniapp/bookservice/valicode`,

  //获取系统日期
  getSystemTime: () => `/omniapp/bookservice/getSystemTime`,

  //上传附件
  uploadFile: () => `/omniapp/bookservice/uploadFile`,

  //获取短信验证码
  getSmsCode: () => `/omniapp/bookservice/getSmsCodePC`,

  //获取物流信息
  getTmsStatus: () => `/omniapp/bookservice/getTmsStatus`,


  //微信支付创建订单
  createOrder: () => `/omniapp/bookservice/createOrder`,

  //微信支付订单查询
  queryOrder: () => `/omniapp/bookservice/queryOrder`,

  //获取省份
  findProvince: () => `/omniapp/bookservice/address/findProvince`,

  //获取城市
  findCity: () => `/omniapp/bookservice/address/findCity`,

  //获取乡区
  findDistinct: () => `/omniapp/bookservice/address/findDistinct`,

  //获取城镇
  findTown: () => `/omniapp/bookservice/address/findTown`,

  //获取维修站
  findAsc: () => `/omniapp/bookservice/address/findAsc`,

  //DI品类校验
  getCheckDI: () => `/omniapp/bookservice/getCheckDI`,

  //根据产品型号获取产品类别
  getProductType:()=> `/casch/outProduct`,

  //获取homepickup暂停服务配置
  getHomePickUpPauseServiceConfig: () => `/omniapp/bookservice/getHomePickUpPauseServiceConfig?t=${new Date().getTime()}`,

  //获取系统维护通知
  getSystemNotice: () => `/omniapp/bookservice/getSystemNotice?t=${new Date().getTime()}`,
}
api.serviceInformation = {
  //上传附件
  uploadFile: () => `/omniapp/bookservice/serviceInformation/uploadFile`,
  //添加
  add: () => `/omniapp/bookservice/serviceInformation/add`,
  //获取列表
  getList: () => `/omniapp/bookservice/serviceInformation/getList`,

  //删除
  delete: () => `/omniapp/bookservice/serviceInformation/delete`,

}

api.member = {
  // 获取会员信息
  getPersonalDetails: () => `/eSolverOmniChannel/account/getPersonalDetails.do`,

  //获取已注册产品
  productRegistrationHistory: () => `/omniapp/bookservice/third-party/getRegProductList`

}
api.prd = 'https://service.sony.com.cn/'

export default api
